import React, { useEffect, useState } from 'react'
import style from './index.module.css'

let bridge: {
  show: (url: string) => any
} | null = null

export function showPreviewImg(url: string) {
  if (bridge) {
    bridge.show(url)
  } else {
    console.error('showPreviewImg bridge is null')
  }
}

export function PreviewImg() {
  const [url, setUrl] = useState('')

  useEffect(() => {
    bridge = {
      show: val => setUrl(val),
    }

    return () => {
      bridge = null
    }
  }, [])

  if (!url) return null

  return (
    <div className={style['Float-check-big-img']}>
      <div className={style['Float-check-big-img-mask']} />
      <div
        className={style['Float-check-big-img-main']}
        onClick={() => {
          setUrl('')
        }}
      >
        <img src={url} alt="" />
      </div>
    </div>
  )
}
